import { compose, createStore, applyMiddleware } from 'redux';
import { withExtraArgument, ThunkDispatch } from 'redux-thunk';
import { reducers } from '../../reducers';
import { IApplicationContext } from '../../types/application';
import { IApplicationState, TReduxActions } from '../../types/redux';
// import { IApplicationContext } from '../../types/applicationContext';

interface IThunkExt {
  dispatch: ThunkDispatch<IApplicationState, IApplicationContext, TReduxActions>;
}

/* istanbul ignore next */
const composeEnhancers = (() => {
  if (process.env.NODE_ENV === 'development' && process.env.IS_BROWSER_BUILD) {
    const { __REDUX_DEVTOOLS_EXTENSION_COMPOSE__ } = window;

    if (__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) {
      return __REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
        name: `map-search-frontend# ${document.title}`,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
      } as any);
    }
  }

  return compose;
})();

/**
 * Хелпер для создания Redux стора
 * @param initialState IApplicationState - предзагруженное состояние
 */
export function createReduxStore(initialState: IApplicationState, context: IApplicationContext) {
  const storeEnchancers = composeEnhancers(applyMiddleware(withExtraArgument(context)));

  return createStore<IApplicationState, TReduxActions, IThunkExt, {}>(reducers, initialState, storeEnchancers);
}
